import { QRCodeCanvas } from 'qrcode.react'

// Full STEP 1 / STEP 2 player join card — one per team, the printable design the
// pro shop hands each team. Renders on screen for preview AND prints one card per
// page (the parent adds a page-break between cards). STEP 1 = everyone scans to
// join + get the app (Android done after this); STEP 2 = iPhone re-scans inside
// the app. Both encode the team's own code.
export default function TeamJoinCard({ teamLabel, step1Url, step2Url }) {
  return (
    <div className="team-join-card" style={CARD}>
      <div style={{ textAlign: 'center', borderBottom: '3px solid #000', paddingBottom: 10, marginBottom: 12 }}>
        <div style={{ fontSize: 11, letterSpacing: '0.25em', fontWeight: 800 }}>PINE BLUFF COUNTRY CLUB</div>
        <div style={{ fontSize: 40, fontWeight: 900, lineHeight: 1.02, margin: '2px 0', letterSpacing: '-0.01em' }}>PBCC 4‑Ball</div>
        <div style={{ fontSize: 20, fontWeight: 800 }}>{teamLabel}</div>
      </div>

      <StepBox
        n="1" title="STEP 1" who="EVERYONE" url={step1Url}
        badge="SCAN THIS CODE FIRST"
        note="Everyone scans this first – iPhone & Android"
        left={<>
          <div style={{ fontSize: 15, fontWeight: 800 }}>📱 SCAN THIS QR CODE →</div>
          <div style={{ marginTop: 10, border: '2px solid #000', borderRadius: 8, padding: '6px 10px', fontWeight: 800, fontSize: 12.5 }}>🤖 ANDROID USERS — YOU ARE DONE!</div>
        </>}
      />

      <StepBox
        n="2" title="STEP 2" who="iPHONE ONLY" url={step2Url}
        badge="SCAN THIS CODE SECOND"
        note="iPhone ONLY – tap the QR Scan tab in the app, then scan this code."
        left={<div style={{ fontSize: 14, fontWeight: 700, lineHeight: 1.9 }}>
          <div>① OPEN THE APP</div>
          <div>② TAP QR SCAN</div>
          <div>③ SCAN THIS QR CODE →</div>
        </div>}
      />

      <div style={{ borderTop: '3px solid #000', marginTop: 4, paddingTop: 8, textAlign: 'center', fontWeight: 800, fontSize: 11.5, lineHeight: 1.4 }}>
        ★ ANDROID USERS ARE FINISHED AFTER STEP 1.<br />iPhone USERS: COMPLETE STEP 2.
      </div>
    </div>
  )
}

function StepBox({ n, title, who, url, badge, note, left }) {
  return (
    <div style={{ border: '2px solid #000', borderRadius: 14, padding: 12, marginBottom: 12, display: 'flex', gap: 12, alignItems: 'center' }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
          <span style={{ background: '#000', color: '#fff', borderRadius: '50%', width: 26, height: 26, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: 15 }}>{n}</span>
          <span style={{ background: '#000', color: '#fff', padding: '2px 10px', fontWeight: 900, fontSize: 15, letterSpacing: '0.05em' }}>{title}</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 900, marginBottom: 6 }}>{who}</div>
        {left}
      </div>
      <div style={{ textAlign: 'center', flexShrink: 0 }}>
        <div style={{ background: '#000', color: '#fff', fontWeight: 800, fontSize: 9, padding: '3px 6px', marginBottom: 5, letterSpacing: '0.03em' }}>{badge}</div>
        <QRCodeCanvas value={url} size={150} marginSize={3} fgColor="#000000" bgColor="#FFFFFF" />
        <div style={{ fontSize: 8.5, width: 158, marginTop: 4, lineHeight: 1.3 }}>{note}</div>
      </div>
    </div>
  )
}

const CARD = {
  width: 420, maxWidth: '100%', margin: '0 auto', background: '#fff', color: '#000',
  border: '3px solid #000', borderRadius: 18, padding: 18, boxSizing: 'border-box',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
}
